import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface MailDeliveryStopState {
  result: boolean
}

export const initialState: MailDeliveryStopState = {
    result: false,
};

export const MailDeliveryStopReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailDeliveryStop,
  (state: MailDeliveryStopState, payload: MailDeliveryStopState) => {
    return payload;
  }
);
